module.exports = __webpack_public_path__ + "img/government-Industry-points4.d1adc9f2.png";